const keys = {
  all: () => ["batteryData"] as const,
  one: (address: number) => [...keys.all(), String(address)] as const,
};

export default keys;
